// « Précédent / Suivant » pager with the "x–y sur total" counter of an admin list.
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PaginationMeta } from '../../../../types/student-requests.types';

interface RequestsPaginationProps {
  meta: PaginationMeta;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export const RequestsPagination: React.FC<RequestsPaginationProps> = ({ meta, onPageChange, disabled }) => {
  if (meta.total === 0) return null;

  const first = (meta.page - 1) * meta.limit + 1;
  const last = Math.min(meta.page * meta.limit, meta.total);
  const totalPages = Math.max(1, Math.ceil(meta.total / meta.limit));

  return (
    <div className="mt-4 flex items-center justify-between text-sm text-gray-600">
      <span>
        {first}–{last} sur {meta.total}
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(meta.page - 1)}
          disabled={disabled || meta.page <= 1}
          className="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronLeft className="w-4 h-4" />
          Précédent
        </button>
        <span className="px-2 text-gray-500">
          Page {meta.page} / {totalPages}
        </span>
        <button
          type="button"
          onClick={() => onPageChange(meta.page + 1)}
          disabled={disabled || meta.page >= totalPages}
          className="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 rounded-lg hover:bg-gray-50 transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Suivant
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default RequestsPagination;
